import filtersSaga from '~/sagas/filters/filters.saga';

export default filtersSaga;
